/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
    BlockTypeSelect,
    BoldItalicUnderlineToggles,
    ListsToggle,
    Separator,
    codeBlockPlugin,
    codeMirrorPlugin,
    frontmatterPlugin,
    headingsPlugin,
    linkDialogPlugin,
    linkPlugin,
    listsPlugin,
    markdownShortcutPlugin,
    quotePlugin,
    tablePlugin,
    thematicBreakPlugin,
    toolbarPlugin,
} from '@mdxeditor/editor'

export const ALL_PLUGINS = [
    toolbarPlugin({
        toolbarContents: () => (
            <>
                {/*<UndoRedo />*/}
                <BoldItalicUnderlineToggles />
                <ListsToggle />
                <Separator />
                <BlockTypeSelect />
                {/*<CreateLink />*/}
                <Separator />
            </>
        ),
    }),
    listsPlugin(),
    quotePlugin(),
    headingsPlugin({ allowedHeadingLevels: [1, 2, 3] }),
    linkPlugin(),
    linkDialogPlugin(),
    // imagePlugin({
    //     imageAutocompleteSuggestions: [
    //         'https://via.placeholder.com/150',
    //         'https://via.placeholder.com/150',
    //     ],
    //     imageUploadHandler: async () => Promise.resolve('https://picsum.photos/200/300'),
    // }),
    tablePlugin(),
    thematicBreakPlugin(),
    frontmatterPlugin(),
    codeBlockPlugin({ defaultCodeBlockLanguage: '' }),
    // sandpackPlugin({ sandpackConfig: virtuosoSampleSandpackConfig }),
    codeMirrorPlugin({
        codeBlockLanguages: {
            js: 'JavaScript',
            css: 'CSS',
            txt: 'Plain Text',
            tsx: 'TypeScript',
            '': 'Unspecified',
        },
    }),
    markdownShortcutPlugin(),
]

export const SHORT_PLUGINS = [
    listsPlugin(),
    quotePlugin(),
    headingsPlugin({ allowedHeadingLevels: [1, 2, 3] }),
    linkPlugin(),
    linkDialogPlugin(),
    tablePlugin(),
    thematicBreakPlugin(),
    frontmatterPlugin(),
    codeBlockPlugin({ defaultCodeBlockLanguage: '' }),
    // sandpackPlugin({ sandpackConfig: virtuosoSampleSandpackConfig }),
    codeMirrorPlugin({
        codeBlockLanguages: {
            js: 'JavaScript',
            css: 'CSS',
            txt: 'Plain Text',
            tsx: 'TypeScript',
            '': 'Unspecified',
        },
    }),
    markdownShortcutPlugin(),
]
